export { useSearchPageNavigator } from "#use-search-page-navigator";
